<template>
  <div class="xsbg-tab">
    <SlideSearch
      :filterList="searchFilter"
      @search="subminSearch"
      @offsearch="offSearch"
    ></SlideSearch>
    <div class="divider"></div>

    <m-textArea class="data-list" ref="dataList">
      <div
        v-for="(item, index) in datalist"
        :key="index"
        class="data-item"
        @click="showContent(item)"
      >
        <div class="video-preview" :style="previewbg(item.preview)">
          <div class="icon-play"></div>
        </div>
        <div class="video-caption">
          <h3>{{ item.title }}</h3>
          <p>主讲人: {{ item.perfomer }}</p>
          <div class="btn-outlink"></div>
        </div>
      </div>
    </m-textArea>

    <VideoPlay
      v-if="contentPage"
      :headers="headers"
      :info="content"
      @closePlayer="contentPage = false"
    ></VideoPlay>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";

import SlideSearch from "./SlideSearch";
import TextArea from "@/components/TextArea";
import Pagination from "@/components/Pagination";
import VideoPlay from "@/components/VideoPlay";

export default {
  components: {
    SlideSearch,
    "m-textArea": TextArea,
    Pagination,
    VideoPlay
  },
  data() {
    return {
      pageName: "report",
      headers: [
        { tag: "title", name: "标题" },
        { tag: "perfomer", name: "讲述人" },
        { tag: "region", name: "地域" },
        { tag: "record_place", name: "录制地" },
        { tag: "keywords", name: "关键词" },
        { tag: "description", name: "简介" }
      ],
      onSearch: false,
      searchFilter: [
        { name: "title", title: "标题" },
        { name: "perfomer", title: "讲述人" },
        { name: "region", title: "地域" },
        { name: "record_place", title: "录制地" },
        { name: "keywords", title: "关键词" },
        { name: "description", title: "简介" }
      ],
      searchParam: {},
      contentPage: false,
      content: {}
    };
  },
  computed: {
    ...mapState(["report"]),
    datalist() {
      if (this.onSearch) {
        return this.report.searchres.content;
      }
      return this.report[this.pageNow];
    },
    pageNow() {
      return this.onSearch ? this.report.searchres.number : this.report.number;
    },
    pages() {
      return this.onSearch
        ? this.report.searchres.total_pages
        : this.report.total_pages;
    }
  },
  filters: {
    title(value) {
      return value.length > 16 ? value.slice(0, 16) + "..." : value;
    }
  },
  mounted() {
    this.getPageData();
  },
  methods: {
    ...mapActions(["getDataList", "searchData"]),
    getPageData(page_num = 0) {
      const param = {
        data_name: this.pageName,
        page_num
      };
      this.getDataList(param);
    },
    chagenPage(num) {
      this.onSearch
        ? this.search(this.searchParam, num)
        : this.getPageData(num);
      this.$refs.dataList.scroll();
    },
    search(param, num = 0) {
      this.searchData({
        data_name: this.pageName,
        page_num: num,
        ...param
      });
      this.searchParam = param;
      this.onSearch = true;
    },
    subminSearch(data) {
      const { category, ...param } = data;

      if (category) {
        param.speciality = category;
      }

      this.search(param);
      this.$refs.dataList.scroll();
    },
    offSearch() {
      this.getPageData();
      this.onSearch = false;
      this.$refs.dataList.scroll();
    },
    previewbg(src) {
      return {
        backgroundImage: src ? `url(${src})` : `url("img/video-default-bg.jpg")`
      };
    },
    showContent(data) {
      this.content = data;
      this.contentPage = true;
    }
  }
};
</script>

<style lang="scss">
@import "../../assets/base";
.xsbg-tab {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 1rem 0;
  overflow: hidden;

  .divider {
    height: 1px;
    padding-top: 1rem;
    border-bottom: 1px dashed rgba(0, 0, 0, 0.15);
  }

  .data-list {
    flex: 1;
    padding-top: 1rem;
    padding-bottom: 1rem;

    .text-main {
      padding: 0;
    }
  }

  .data-item {
    margin-bottom: 1rem;
  }

  .video-preview {
    position: relative;
    height: 56.25vw;
    overflow: hidden;
    background-position-y: center;
    background-size: 100%;
    @include img-fluid;

    .icon-play {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate3d(-50%, -50%, 0);
      width: 3rem;
      height: 3rem;
      border: 1px solid #fff;
      background-color: rgba(0, 0, 0, 0.25);
      border-radius: 100%;
    }

    .icon-play:after {
      content: "";
      position: relative;
      left: 50%;
      margin-left: -0.125rem;
      @include center-y;
      display: block;
      width: 0px;
      height: 0px;
      border: 0.5rem transparent solid;
      border-left-color: #fff;
    }
  }

  .video-caption {
    position: relative;
    padding: 0.5rem 1rem;
    background-color: #f7f1da;

    @include title-h3(0.875rem);
    h3 {
      margin: 0;
      font-size: 0.875rem;
      line-height: 1.2;
      height: 1.05rem;

      &::before,
      &::after {
        height: 1.05rem;
      }

      &::before {
        background-image: url("~@/assets/img/video/title-left.png");
      }

      &::after {
        background-image: url("~@/assets/img/video/title-right.png");
      }
    }

    p {
      margin: 0;
      font-size: 0.875rem;
      line-height: 1.8;
    }

    .btn-outlink {
      position: absolute;
      top: 1rem;
      right: 1rem;
      width: 1.25rem;
      height: 1.25rem;
      background-image: url("~@/assets/img/video/icon-outlink.png");
      background-repeat: no-repeat;
      background-size: 100%;
    }
  }
}
</style>